export default __webpack_public_path__ + "static/media/snappy.linux-x64-gnu.8bc00ec0.node";